import { statuses } from './statuses'
import { statuses as statusesApi } from '../../PurchasesApi'

export const status2apiMap: Map<string, (typeof statusesApi)[keyof typeof statusesApi] | null> =
  new Map([
    [statuses.All, null],
    [statuses.Pending, statusesApi.PENDING],
    [statuses.Spent, statusesApi.SPENT],
    [statuses.Removed, statusesApi.DELETED],
  ])
